// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"33efc51855429ca747b3","293":"c88701fd72865322ebb8","461":"ddf80f84d9c8d73fa2b5","518":"4e4ad31baa965925da5f","779":"532c7d231e4b84e46c48"}[chunkId] + ".js";
};